import type { ListProps } from '@mui/material/List';
import List from '@mui/material/List';

const StyleSheet = {
  root: {
    padding: 0,
  },
};

function SidebarGroup(props: ListProps) {
  return <List {...props} sx={StyleSheet.root} />;
}

SidebarGroup.displayName = 'SidebarGroup';
export default SidebarGroup;
